export default {
  'diagram3-5c': {
    'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework`,
    'structure-answers-title': `Elements of the problem definition`,
    'situation-title': 'situation',
    'diagram-header': 'Cascade Group',
    'first-box': 'AZ',
    'second-box': 'CA',
    'third-box': 'IA & SD',
    'fourth-box': 'MA',
    'situation-desc': 'DISTURBING EVENT',
    'bottom-box-points': `
        <ul>
            <li>10-15 years old, single-layered, transaction orientated, monolithic</li>
            <li>Subject to numerous complaints by users</li>
        </ul>`,
    'desc-text': 'All plans do roughly the same thing, but with some local differences',
    'desc-text-2': 'Each plan has its own IT system. All are',
    answers: {
      'r1-top': `
        <p>Systems can’t cope:</p>
        <ul>
            <li>- Inflexible structure</li>
            <li>- Narrow access to info across the system</li>
            <li>- Complex to use</li>
            <li>- High cost to operate</li>
        </ul>`,
      'r2-top': `
        <p>Systems that can cope:</p>
        <ul>
            <li>- Flexible, open, user friendly, modular</li>
            <li>- Accessible to all users across the system</li>
        </ul>`,
      'solution-bottom': `<p>Design a common core architecture around which each Plan can design its system to suit the characteristics of its market?</p>`
    }
  }
}

// export default {
//     'diagram3-5c': {
//       'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework.
//       There may be more than one element for each position<br/>
//       Once completed, the pyramid builder will be provided for you to complete the next part of this exercise`,
//       'structure-answers-title': `Elements of the problem definition`
//     }
// }



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram3/i18n/en.js